var map = {
	"./attach/attach": 9,
	"./attach/attach.js": 9,
	"./attach/package": 10,
	"./attach/package.json": 10,
	"./fit/fit": 11,
	"./fit/fit.js": 11,
	"./fit/package": 12,
	"./fit/package.json": 12,
	"./fullscreen/fullscreen": 13,
	"./fullscreen/fullscreen.css": 35,
	"./fullscreen/fullscreen.js": 13,
	"./fullscreen/package": 14,
	"./fullscreen/package.json": 14,
	"./search/SearchHelper": 4,
	"./search/SearchHelper.js": 4,
	"./search/SearchHelper.js.map": 36,
	"./search/search": 15,
	"./search/search.js": 15,
	"./search/search.js.map": 37,
	"./terminado/package": 16,
	"./terminado/package.json": 16,
	"./terminado/terminado": 17,
	"./terminado/terminado.js": 17
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;


//////////////////
// WEBPACK FOOTER
// /tmp/binderhub/node_modules/xterm/lib/addons ^\.\/.*$
// module id = 34
// module chunks = 0